export default "__VITE_ASSET__DUQb6dXn__"